import { createStyles } from '@material-ui/core'

const styles = theme =>
  createStyles({
    buttonSearch: {
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: 'unset',
      },
    },
    container: {
      ...theme.flexRowCenter,
      justifyContent: 'space-between',
    },
    searchField: {
      width: '30rem',
      backgroundColor: 'white',
      borderRadius: '4px',
      color: theme.palette.primary.main,
      margin: 0,
      borderCollapse: 'separate',
      '&:after, &:before': {
        content: 'unset',
      },
      '& > div': {
        margin: 0,
        position: 'absolute',
        right: 0,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        height: '39px',
        width: '39px',
        borderRadius: '0 4px 4px 0',
        top: 'unset',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxHeight: '39px',
        '&:after, &:before': {
          content: 'unset',
        },
      },
      '& > input': {
        paddingLeft: '15px',
        height: '26px',
      },
      '& > input::placeholder': {
        color: theme.palette.primary.main,
      },
    },
  })

export default styles
